import { memo, useEffect, useMemo, useRef, useState } from "react";
import { ArrowForwardIosSharp } from "@mui/icons-material";
import { Accordion, AccordionSummary } from "@mui/material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

import classNames from "common/class-names";

import AppAccordionDto from "dto/components/app-accordion-dto";

import AppButton from "./app-button";

const AppAccordion = ({ title, children, className = "", onDelete, defaultActiveIndex = false }: AppAccordionDto) => {
	const accordionRef = useRef<HTMLDivElement>(null);
	const [isOpen, setIsOpen] = useState<boolean>(false);

	const accordionClassname = useMemo(() => {
		return classNames({
			"app-accordion": true,
			...(className && {
				[className]: true,
			}),
		});
	}, [className]);

	const handleOnClickAccordionTab = () => {
		setIsOpen((prev) => !prev);
	};

	useEffect(() => {
		if (defaultActiveIndex && !isOpen && accordionRef.current) {
			setIsOpen(true);
			accordionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [defaultActiveIndex]);

	return (
		<Accordion className={accordionClassname} expanded={isOpen}>
			<AccordionSummary ref={accordionRef} className="accordion__header" expandIcon={<ArrowForwardIosSharp sx={{ fontSize: "12px" }} />} onClick={() => handleOnClickAccordionTab()}>
				<p className="accordion__header-title">{title}</p>

				{onDelete && <AppButton type="button" label="" text icon={<DeleteOutlineOutlinedIcon />} onClick={onDelete} />}
			</AccordionSummary>

			{children}
		</Accordion>
	);
};

export default memo(AppAccordion);
